// Imported so Vite emits it as a hashed /assets file (1y immutable). The old `./src/assets/sounds/...`
// string resolved against the current route, hit the SPA fallback and got index.html back — ~3.4M
// wasted requests a day, and the sound never played.
import rewards from '../../assets/sounds/rewards.mp3';

export const CLAIM_REWARDS_ANIMATION_SOUNDS = {
  rewards,
};
